/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */

/**
 * Available status for Employer's Reference Number ern field
 * - EXEMPT: the client is exempt from informe ERN
 * - PENDING: the ERN is necessary, but was not informed in the Quot purchase
 * - INFORMED: the ERN was informed
 */
export var ERNStatus;

(function (ERNStatus) {
  ERNStatus["EXEMPT"] = "exempt";
  ERNStatus["PENDING"] = "pending";
  ERNStatus["INFORMED"] = "informed";
})(ERNStatus || (ERNStatus = {}));